import { useMemo } from 'react';
import { useCategories } from './useCategories';

export interface PopularItem {
  id: number;
  name: string;
  description?: string;        // ✅ added
  parentCategory: string;
  badge: 'Trending' | 'Popular';
}


export const usePopularSubcategories = () => {
  const { categories, loading } = useCategories();

  const items = useMemo<PopularItem[]>(() => {
    if (!Array.isArray(categories)) return [];

    return categories.flatMap(category =>
      (category.subCategories || [])
        .filter(sub => sub.isTrending || sub.isPopular)
        .map(sub => ({
          id: sub.id,
          name: sub.name,
          description: sub.description,     
          parentCategory: category.name,
          badge: sub.isTrending ? 'Trending' : 'Popular',
        }))
    );
  }, [categories]);

  return { items, loading };
};
